import { parseXmlElementColor } from '@/common/utils/parseXmlElementColor'

/**
 * Swing JJColorHelper.parseColor for UniData field attributes.
 * `#` / `0x` go through the XML helper. A bare integer is Java `new Color(int)` (opaque RGB).
 */
export function parseSwingFieldColor(raw: unknown): string | undefined {
  if (raw == null) return undefined
  const color = String(raw).trim()
  if (!color) return undefined
  if (color.startsWith('#') || /^0x/i.test(color)) {
    return parseXmlElementColor(color)
  }
  if (/^-?\d+$/.test(color)) {
    const n = Number(color)
    if (!Number.isSafeInteger(n)) return undefined
    const rgb = n >>> 0
    const r = (rgb >> 16) & 0xff
    const g = (rgb >> 8) & 0xff
    const b = rgb & 0xff
    const hex = [r, g, b].map((part) => part.toString(16).padStart(2, '0')).join('')
    return `#${hex}`
  }
  return undefined
}
